<template>
    <div>
        <div class="">
            <h6 style="float: left;">Product Add-ons</h6>
            <div id="setAddProductAddons" style="display:none; clear:both; margin-top: 1em;">
              <div class="" style="margin-bottom: 5px;">
                <button class="btn sp-button-sm" style="float: left; background:#5883a0; color:#ffffff;" @click="toggleSingleComponent('setAddProductAddons')">Cancel</button>
                <button class="btn sp-button-sm" style="float: right; background:#008cff; color:#ffffff;" @click="addToProductAddons()">Done, Add Products to Add-ons</button>
                <div style="clear: both;"></div>
              </div>
              <h5 style="color:#ff0000">Please select products</h5>
              <div class="card card-flat-pad" v-for="(cat,casndex) in sellpoint.business_categories" :key="casndex" style="height:auto">
                <div class="" style="float: left;">
                  <h5>{{cat.business_category_name}}</h5>
                </div>
                <div class="" style="float: right;">
                  <button class="btn sp-button-sm" style="background:#5883a0; color:#ffffff;" @click="category=cat; getBusinessCategoryProducts('CATSET'+casndex); setMenuTabInnerView(menu_tab_inner_view['SHCPRDS'+casndex] ? ' ' : ('SHCPRDS'+casndex));">Select <i class="fa fa-angle-down"></i></button>
                </div>
                <div style="clear: both;"></div>
                <div class="card" v-if="menu_tab_inner_view['SHCPRDS'+casndex]">
                  <div class="container" v-if="component_loading['CATSET'+casndex]">
                    <div class="row">
                      <div class="loading-sm"></div>
                    </div>
                  </div>
                  <div v-else>
                    <div style="float:left; width:30%; clear:right; padding: 1em;" v-for="(prd,prddex) in cat.category_products" :key="prddex">
                      <div v-if="product.product_id != prd.product_id" class="card" style="padding-top:1em; width: auto; height: auto;">
                        <input type="checkbox" @click="setAddToProductAddons(prd)"/>
                        <div class="card-avatar-square card-label-avatar">
                          <img v-if="prd.product_images && (prd.product_images.length != 0)" :src="prd.product_images[0].product_image">
                          <img v-else src="/static/assets/images/dummy-image.png">
                        </div>
                        <p><b>{{prd.product_name}}</b></p>
                      </div>
                    </div>
                    <div style="margin-top: 5px;">
                      <button class="btn sp-button-sm" style="float: right; background:#ff0066; color:#ffffff;" @click="addToProductAddons()">Done, Add Products to Add-ons</button>
                      <div style="clear: both;"></div>
                    </div>
                  </div>
                  <div style="clear: both;"></div>
                </div>  
              </div>
            </div>
            <div>
              <div class="" style="float: right; margin-bottom: 5px;">
                <button class="btn sp-button-02 sp-button-sm" @click="toggleSingleComponent('setAddProductAddons')">Add Products Add-ons</button>
              </div>
              <div style="clear:both;"></div>
              <div v-if="product.product_addons && (product.product_addons.length != 0)">
                <div class="card col-xs-4 card-col-2" v-for="(product,index) in product.product_addons" :key="index" style="margin-bottom: 2.2em;"> 
                    <a @click="setProduct(product)" style="text-decoration: none; color:inherit;">
                    <!-- <span class="card-thumb-up-left"><i class="fa fa-shopping-bag"></i></span> -->
                    <div class="card-col-img" style="">
                        <img v-if="product.product_images[0]" :src="product.product_images[0].product_image" class="img-responsive" style="max-height:8em;">
                        <img v-else src="/static/assets/images/dummy-image.png">
                    </div>
                    <div class="card-col-details" style="display:block; padding: 3px;">
                        <p style="font-size:13px; text-align: center;" class="prd-name">{{product.product_name}}<br>
                            <span v-if="product.product_items[0]" class="sp-app-default-color" style="font-weight:bolder;">₦{{product.product_items[0].product_item_price_f}}</span>
                            <br>
                            <span><b>Stock: </b>{{product.product_items[0].product_item_quantity}}</span>
                        </p>
                    </div>
                    </a>
                    <div style="clear: both;"></div>
                </div>
                <div style="clear: both;"></div>
              </div>
              <div v-else> <p class="sp-app-default-color">No product addons</p></div>
            </div>
          </div>
        </div>
</template>

<style>
 @import url("style.css");
</style>

<script>
    import commonfunctions from "../../Resources/commonfunctions";
    export default {
        mixins: [commonfunctions],
        data () {
            return {
              no_data: true,
            }
        },

        methods: {
            setPage(){
                let self = this;
                localforage.getItem('xvue', function(err, value) { //quick with the callback version
                    if(value != undefined) {
                        self.sellpoint =  value.account.store_sellpoint.store_sellpointData;
                        self.product =  value.account.store_sellpoint.store_product;
                    }else{}
                });
           
            },
        },

        components: {},

        created: function(){
            this.setPage();
        }
    }
</script>



// WEBPACK FOOTER //
// ProductAddons.vue?03813be0